<template>
  <div :class="ui.bkgdColor">
    <!-- {{getResultsList}} -->
    <v-layout row class="ml-3 mt-3 mr-3">
      <v-chip :color="ui.chipColor" :class="ui.textSubheadingBold">
        {{resultsObj.title}}
      </v-chip>
      <v-spacer/>
      <v-chip :color="ui.chipColor" :class="ui.textSubheading">
        <v-icon left :color="ui.btnColor">playlist_add</v-icon>
        <div v-if="getResultsList.length === null">
          0
        </div>
        <div v-else>
          {{getResultsList.length}}
        </div>
      </v-chip>
    </v-layout>
    <ResultsList :attachments="{editUnlock: true, attach: []}"/>
    <v-layout row class="mr-1 mt-4">
      <v-spacer/>
      <ResultsNew v-if="enableResultAdd"/>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import ResultsNew from "@/engineering/results/components/ResultsNew";
import ResultsList from "@/engineering/results/components/ResultsList";

export default {
  // eslint-disable-next-line
  mixins: [apptheme],
  components: {
    ResultsList,
    ResultsNew
  },
  props: {
    attachments: {
      type: Object
    }
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getCurrentPage",
      "getResultsList",
      "getResultsListCounter",
      "getDetail",
      "getDetailLink"
    ]),
    enableResultAdd() {
      let logic = false;
      if (this.getCurrentPage === "/worktooldetail") {
        logic = false;
      } else {
        logic = true;
      }
      return logic;
    },
    resultsObj() {
      let obj = {
        title: ""
      };
      if (this.getDetailLink !== null) {
        if (
          this.getDetailLink.epdid !== undefined &&
          this.getDetailLink.epdid !== ""
        ) {
          let epid = this.getDetailLink.epid;
          obj.title = "Results Plan " + epid;
        } else {
          obj.title = "Inspection and Test Plan";
        }
      } else {
        obj.title = "Inspection and Test Plan";
      }
      return obj;
    },
    list() {
      // eslint-disable-next-line
      if (this.getResultsList !== undefined && this.getResultsList.length !== 0) {
        return this.getResultsList; // used for new attachments
      } else if (this.getResultsList === undefined) {
        return [];
      } else if (this.getResultsList.length !== 0) {
        return this.getResultsList;
      } else {
        return [];
      }
    },
    ui() {
      return this.uiTheme1;
    }
  },
  data() {
    return {
      dialog: false,
      valid: false,
      enableEditBtn: false
    };
  }
};
</script>
